import { graphql } from 'gatsby';
import * as React from 'react';
import { useLocalize } from '../components/localize-context';
import { Seo } from '../components/seo';
import { ComboBookingForm } from '../components/combo-booking-form';

export default function Combo({ data: { prismicServiceCombo } }) {
  const l = useLocalize();

  return (
    <>
      <Seo title={l('Combo')} />
      <div className="container py-6 px-4 max-w-3xl mx-auto">
        <h1 className="text-3xl mb-4">{l('Combo')}</h1>
        <ComboBookingForm combo={prismicServiceCombo.data} />
      </div>
    </>
  );
}

export const pageQuery = graphql`
  query ComboQuery($lang: String!) {
    prismicServiceCombo(lang: { eq: $lang }) {
      ...ComboBookingForm
    }
  }
`;
